import React from 'react';

export default () => <div className={'loading'}>Loading...</div>;